import { useEffect, useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { faAdd, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Tabs from "../../../Components/Common/Tabs";
import { subChapterTabsData } from "../../../data/SidebarData";
import Modal from "../../../Components/Common/Modal";
import SubChapterForm from "./Components/SubChapterForm";
import useSWRMutation from "swr/mutation";
import { chapterUrls, subchapterUrls } from "../../../Api/Auth/ApiUrls";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useSWR from "swr";
import QueryString from "qs";
import useTable from "../../../hooks/useTable";
import useToastError from "../../../hooks/useErrorToast";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import { Loader } from "../../../Components/Common/Loader";
import NoData from "../../../Components/Common/NoData";
import SubChapterRow from "./Components/SubChapterRow";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import NotFound from "../../Notfound";

const tableColumnData = [
  { id: "title", label: "Title" },
  { id: "createdAt", label: "Created" },
];
const SubChaptersList = () => {
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });
  const { showErrorToast } = useToastError();
  const { id } = useParams();

  const [isModalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          title: "",
          description: "",
        });
        setModalOpen(true);
      },
    },
    {
      label: "Back",
      icon: faArrowLeft,
      onClick: () => {
        navigate(-1);
      },
    },
  ];

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
    chapter: id,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate, error } = useSWR(
    subchapterUrls.list(apiQueryString)
  );
  const { data: chapterData } = useSWR(chapterUrls.single(id));

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const onEditClick = (row) => {
    setRow(row);
    handleInputChange("title", row.title);
    handleInputChange("description", row.description);
    setModalOpen(true);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const { trigger, isMutating } = useSWRMutation(
    subchapterUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    subchapterUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    row ? EditTrigger(formData) : trigger({ ...formData, chapter: id });
  };
  useEffect(() => {
    if (error?.message) {
      if (error.message === "Request failed with status code 400") {
        toast.error("Chapter Id is not valid");
      }
    }
  }, [error]);

  if (error?.message === "Request failed with status code 400") {
    return <NotFound />;
  }
  const chapterTitle = chapterData?.chapter?.title;

  return (
    <div>
      <Breadcrumb
        actionButtons={actionButtons}
        noNavigate
        customBreadcrumb={[
          chapterTitle ? `Chapters(${chapterTitle})` : "Chapters",
          "Subchapters",
        ]}
      />
      <Tabs tabs={subChapterTabsData} />

      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <SubChapterRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={row ? "Edit Sub Chapter" : "Create Sub Chapter"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
        formWidth
      >
        <SubChapterForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
        />
      </Modal>
    </div>
  );
};

export default SubChaptersList;
